import type { PbxLocation } from '@mangovoice/types'

import type { ApiError } from '../api/pbxLocationsApi.types'

export const formatE911Address = (location: PbxLocation): string | null => {
  if (!location.phone_number) return null
  const parts = [
    location.phone_number.e911_address,
    location.phone_number.e911_address_2,
    location.phone_number.e911_city,
    location.phone_number.e911_state,
    location.phone_number.e911_postal_code,
  ].filter((part): part is string => Boolean(part && part.trim().length > 0))
  if (parts.length === 0) return null
  return parts.join(', ')
}

export const composeApiErrorMessage = (
  error: ApiError | undefined,
  fallback: string,
): string => {
  if (!error) return fallback
  if (typeof error.message === 'string' && error.message.length > 0) {
    return error.message
  }
  if (error.parameters && error.parameters.length > 0) {
    return error.parameters.map((p) => p.message).join(' ')
  }
  return fallback
}
